import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { Loader } from '@/components/loaders/loader';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { IUser } from '../types';

interface ImpersonateProps {
  onCancel: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  user: IUser | null;
  signingIn: boolean;
}

const Impersonate = ({ onCancel, onConfirm, isOpen, user, signingIn }: ImpersonateProps) => {
  if (!user) return <></>;

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onCancel}
      confirmButton={
        !signingIn
          ? {
              name: 'Impersonate User',
              onClick: onConfirm
            }
          : undefined
      }
      showCancelButton={!signingIn}
    >
      <ModalContainer>
        {signingIn && (
          <>
            <ModalTitel>Signing In As</ModalTitel>
            <ModalText fontWeight="400">
              {user.tenant.name} ({user.email})...
              <br /> <br />
              <Loader size={30} />
            </ModalText>
          </>
        )}
        {!signingIn && (
          <>
            <ModalTitel>Impersonate User?</ModalTitel>
            <ModalText fontWeight="400">
              This action will allow you to act on behalf of <ModalText fontWeight="700">{user.email}</ModalText>. Your session will switch to{' '}
              <ModalText fontWeight="700">{user.tenant.name}</ModalText> and your level of access will temporarily mirror that of this user.
            </ModalText>
          </>
        )}
      </ModalContainer>
    </ModalWrappedContent>
  );
};

export default Impersonate;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 30px 0;
`;

const ModalTitel = styled.div`
  color: ${themeVar('font.strong')};
  text-align: center;
  font-family: Blinker;
  font-size: 33px;
  font-style: normal;
  font-weight: 400;
  line-height: 46.2px;
`;

const ModalText = styled.span<{ fontWeight: string }>`
  color: ${themeVar('font.base')};
  text-align: center;
  font-family: Blinker;
  font-size: 19px;
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight};
  line-height: 26.6px;
`;
